module.exports = __webpack_public_path__ + "static/img/kappa.56b574d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kappa.png
// module id = TIuV
// module chunks = 0